import DashboardAndPenguinSvg from "./dashboard-and-penguin.svg";

export const DashboardAndPenguin = () => {
  return <DashboardAndPenguinSvg />;
};
